function carinaFontReset(theme) {
  return {
    fontFamily: theme.font.base.family,
    fontStyle: 'normal',
    fontWeight: theme.font.base.weight.regular,
    letterSpacing: 'normal',
    lineHeight: theme.font.lineHeight.base,
    textAlign: 'left',
    textIndent: 0,
    textShadow: 'none',
    textTransform: 'none'
  };
}

export { carinaFontReset };
